 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE from '@/components/love'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK11COVER from '@/components/Book1/1-cover'
 import BOOK12TITLE_PAGE from '@/components/Book1/2-title_page'
 import BOOK14CHAP1 from '@/components/Book1/4-chap1'
 import BOOK15CHAP2 from '@/components/Book1/5-chap2'
 import BOOK16CHAP3 from '@/components/Book1/6-chap3'
 import BOOK17CHAP4 from '@/components/Book1/7-chap4'
 import BOOK18CHAP5 from '@/components/Book1/8-chap5'
 import BOOK19CHAP6 from '@/components/Book1/9-chap6'
 import BOOK110CHAP7 from '@/components/Book1/10-chap7'
 import BOOK111CHAP8 from '@/components/Book1/11-chap8'
 import BOOK112CHAP9 from '@/components/Book1/12-chap9'
 import BOOK113CHAP10 from '@/components/Book1/13-chap10'
 import BOOK114CHAP11 from '@/components/Book1/14-chap11'
 import BOOK115CHAP12 from '@/components/Book1/15-chap12'
 import BOOK116CHAP13 from '@/components/Book1/16-chap13'
 import BOOK117CHAP14 from '@/components/Book1/17-chap14'
 import BOOK118CHAP15 from '@/components/Book1/18-chap15'
 import BOOK119CHAP16 from '@/components/Book1/19-chap16'
 import BOOK120CHAP17 from '@/components/Book1/20-chap17'
 import BOOK121CHAP18 from '@/components/Book1/21-chap18'
 import BOOK122CHAP19 from '@/components/Book1/22-chap19'
 import BOOK123CHAP20 from '@/components/Book1/23-chap20'
 import BOOK124CHAP21 from '@/components/Book1/24-chap21'
 import BOOK125CHAP22 from '@/components/Book1/25-chap22'
 import BOOK126CHAP23 from '@/components/Book1/26-chap23'
 import BOOK127CHAP24 from '@/components/Book1/27-chap24'
 import BOOK128CHAP25 from '@/components/Book1/28-chap25'
 import BOOK129CHAP26 from '@/components/Book1/29-chap26'
 import BOOK130CHAP27 from '@/components/Book1/30-chap27'
 import BOOK131CHAP28 from '@/components/Book1/31-chap28'
 import BOOK132CHAP29 from '@/components/Book1/32-chap29'
 import BOOK133CHAP30 from '@/components/Book1/33-chap30'
 import BOOK134CHAP31 from '@/components/Book1/34-chap31'
 import BOOK135CHAP32 from '@/components/Book1/35-chap32'
 import BOOK136CHAP33 from '@/components/Book1/36-chap33'
 import BOOK137CHAP34 from '@/components/Book1/37-chap34'
 import BOOK138CHAP35 from '@/components/Book1/38-chap35'
 import BOOK139CHAP36 from '@/components/Book1/39-chap36'
 import BOOK140CHAP37 from '@/components/Book1/40-chap37'
 import BOOK141CHAP38 from '@/components/Book1/41-chap38'
 import BOOK142CHAP39 from '@/components/Book1/42-chap39'
 import BOOK143CHAP40 from '@/components/Book1/43-chap40'
 import BOOK144CHAP41 from '@/components/Book1/44-chap41'
 import BOOK21COVER from '@/components/Book2/1-cover'
 import BOOK22TITLE_PAGE from '@/components/Book2/2-title_page'
 import BOOK24START from '@/components/Book2/4-start'
 import BOOK25CHAP2 from '@/components/Book2/5-chap2'
 import BOOK26CHAP3 from '@/components/Book2/6-chap3'
 import BOOK27CHAP4 from '@/components/Book2/7-chap4'
 import BOOK28CHAP5 from '@/components/Book2/8-chap5'
 import BOOK29CHAP6 from '@/components/Book2/9-chap6'
 import BOOK210CHAP7 from '@/components/Book2/10-chap7'
 import BOOK211CHAP8 from '@/components/Book2/11-chap8'
 import BOOK212CHAP9 from '@/components/Book2/12-chap9'
 import BOOK213CHAP10 from '@/components/Book2/13-chap10'
 import BOOK214CHAP11 from '@/components/Book2/14-chap11'
 import BOOK215CHAP12 from '@/components/Book2/15-chap12'
 import BOOK216CHAP13 from '@/components/Book2/16-chap13'
 import BOOK217CHAP14 from '@/components/Book2/17-chap14'
 import BOOK218CHAP15 from '@/components/Book2/18-chap15'
 import BOOK219CHAP16 from '@/components/Book2/19-chap16'
 import BOOK220CHAP17 from '@/components/Book2/20-chap17'
 import BOOK221CHAP18 from '@/components/Book2/21-chap18'
 import BOOK222CHAP19 from '@/components/Book2/22-chap19'
 import BOOK223CHAP20 from '@/components/Book2/23-chap20'
 import BOOK224CHAP21 from '@/components/Book2/24-chap21'
 import BOOK225CHAP22 from '@/components/Book2/25-chap22'
 import BOOK226CHAP23 from '@/components/Book2/26-chap23'
 import BOOK227CHAP24 from '@/components/Book2/27-chap24'
 import BOOK228CHAP25 from '@/components/Book2/28-chap25'
 import BOOK229CHAP26 from '@/components/Book2/29-chap26'
 import BOOK230CHAP27 from '@/components/Book2/30-chap27'
 import BOOK231CHAP28 from '@/components/Book2/31-chap28'
 import BOOK232CHAP29 from '@/components/Book2/32-chap29'
 import BOOK233CHAP30 from '@/components/Book2/33-chap30'
 import BOOK234CHAP31 from '@/components/Book2/34-chap31'
 import BOOK235CHAP32 from '@/components/Book2/35-chap32'
 import BOOK236CHAP33 from '@/components/Book2/36-chap33'
 import BOOK237CHAP34 from '@/components/Book2/37-chap34'
 import BOOK238CHAP35 from '@/components/Book2/38-chap35'
 import BOOK239CHAP36 from '@/components/Book2/39-chap36'
 import BOOK240CHAP37 from '@/components/Book2/40-chap37'
 import BOOK241CHAP38 from '@/components/Book2/41-chap38'
 import BOOK242CHAP39 from '@/components/Book2/42-chap39'
 import BOOK31COVER from '@/components/Book3/1-cover'
 import BOOK32TITLE_PAGE from '@/components/Book3/2-title_page'
 import BOOK34START from '@/components/Book3/4-start'
 import BOOK35CHAP2 from '@/components/Book3/5-chap2'
 import BOOK36CHAP3 from '@/components/Book3/6-chap3'
 import BOOK37CHAP4 from '@/components/Book3/7-chap4'
 import BOOK38CHAP5 from '@/components/Book3/8-chap5'
 import BOOK39CHAP6 from '@/components/Book3/9-chap6'
 import BOOK310CHAP7 from '@/components/Book3/10-chap7'
 import BOOK311CHAP8 from '@/components/Book3/11-chap8'
 import BOOK312CHAP9 from '@/components/Book3/12-chap9'
 import BOOK313CHAP10 from '@/components/Book3/13-chap10'
 import BOOK314CHAP11 from '@/components/Book3/14-chap11'
 import BOOK315CHAP12 from '@/components/Book3/15-chap12'
 import BOOK316CHAP13 from '@/components/Book3/16-chap13'
 import BOOK317CHAP14 from '@/components/Book3/17-chap14'
 import BOOK318CHAP15 from '@/components/Book3/18-chap15'
 import BOOK319CHAP16 from '@/components/Book3/19-chap16'
 import BOOK320CHAP17 from '@/components/Book3/20-chap17'
 import BOOK321CHAP18 from '@/components/Book3/21-chap18'
 import BOOK322CHAP19 from '@/components/Book3/22-chap19'
 import BOOK323CHAP20 from '@/components/Book3/23-chap20'
 import BOOK324CHAP21 from '@/components/Book3/24-chap21'
 import BOOK325CHAP22 from '@/components/Book3/25-chap22'
 import BOOK326CHAP23 from '@/components/Book3/26-chap23'
 import BOOK327CHAP24 from '@/components/Book3/27-chap24'
 import BOOK328CHAP25 from '@/components/Book3/28-chap25'
 import BOOK329CHAP26 from '@/components/Book3/29-chap26'
 import BOOK330CHAP27 from '@/components/Book3/30-chap27'
 import BOOK331CHAP28 from '@/components/Book3/31-chap28'
 import BOOK332CHAP29 from '@/components/Book3/32-chap29'
 import BOOK333CHAP30 from '@/components/Book3/33-chap30'
 import BOOK334CHAP31 from '@/components/Book3/34-chap31'
 import BOOK335CHAP32 from '@/components/Book3/35-chap32'
 import BOOK336CHAP33 from '@/components/Book3/36-chap33'
 import BOOK337CHAP34 from '@/components/Book3/37-chap34'
 import BOOK338CHAP35 from '@/components/Book3/38-chap35'
 import BOOK339CHAP36 from '@/components/Book3/39-chap36'
 import BOOK340CHAP37 from '@/components/Book3/40-chap37'
 import BOOK341CHAP38 from '@/components/Book3/41-chap38'
 import BOOK342CHAP39 from '@/components/Book3/42-chap39'
 import BOOK343CHAP40 from '@/components/Book3/43-chap40'
 import BOOK344CHAP41 from '@/components/Book3/44-chap41'
 import BOOK345CHAP42 from '@/components/Book3/45-chap42'
 import BOOK346CHAP43 from '@/components/Book3/46-chap43'
 import LOVE1 from '@/components/love1'
 import BOOK3TEASER00 from '@/components/Book3/teaser00'
 import BOOK3TEASER01COVER from '@/components/Book3/teaser01-cover'
 import BOOK3TEASER01 from '@/components/Book3/teaser01'
 import BOOK3TEASER02 from '@/components/Book3/teaser02'
 import BOOK3TEASER03 from '@/components/Book3/teaser03'
 import COMONAUTHOR from '@/components/Comon/Author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONAUBA from '@/components/Comon/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/1-cover",
 			"name" : "Book1/1-cover",
 			"component" : BOOK11COVER
 		},
 		{
 			"path" : "/Book1/2-title_page",
 			"name" : "Book1/2-title_page",
 			"component" : BOOK12TITLE_PAGE
 		},
 		{
 			"path" : "/Book1/4-chap1",
 			"name" : "Book1/4-chap1",
 			"component" : BOOK14CHAP1
 		},
 		{
 			"path" : "/Book1/5-chap2",
 			"name" : "Book1/5-chap2",
 			"component" : BOOK15CHAP2
 		},
 		{
 			"path" : "/Book1/6-chap3",
 			"name" : "Book1/6-chap3",
 			"component" : BOOK16CHAP3
 		},
 		{
 			"path" : "/Book1/7-chap4",
 			"name" : "Book1/7-chap4",
 			"component" : BOOK17CHAP4
 		},
 		{
 			"path" : "/Book1/8-chap5",
 			"name" : "Book1/8-chap5",
 			"component" : BOOK18CHAP5
 		},
 		{
 			"path" : "/Book1/9-chap6",
 			"name" : "Book1/9-chap6",
 			"component" : BOOK19CHAP6
 		},
 		{
 			"path" : "/Book1/10-chap7",
 			"name" : "Book1/10-chap7",
 			"component" : BOOK110CHAP7
 		},
 		{
 			"path" : "/Book1/11-chap8",
 			"name" : "Book1/11-chap8",
 			"component" : BOOK111CHAP8
 		},
 		{
 			"path" : "/Book1/12-chap9",
 			"name" : "Book1/12-chap9",
 			"component" : BOOK112CHAP9
 		},
 		{
 			"path" : "/Book1/13-chap10",
 			"name" : "Book1/13-chap10",
 			"component" : BOOK113CHAP10
 		},
 		{
 			"path" : "/Book1/14-chap11",
 			"name" : "Book1/14-chap11",
 			"component" : BOOK114CHAP11
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js